import './../../css/loader.css'
import React, { Component } from 'react'

export default class Loader extends Component {
    render() {
        return (
            <div>
                <div className='loader-circle-1'></div>
            </div>
        )
    }
}
